export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000/api',
  userAppUrl: 'https://web-eight-theta-70.vercel.app/',
  supabase: {
    url: 'https://lggeiriskhriqtvjfsqm.supabase.co',
    anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnZ2Vpcmlza2hyaXF0dmpmc3FtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODg3ODk3MjYsImV4cCI6MjEwNDM2NTcyNn0.Dyh2RayeyQo7dEySNDP6tzc_M4kQRhtv0oXp5LHy8Ew'
  },
  importUsersTemplateUrl: 'https://lggeiriskhriqtvjfsqm.supabase.co/storage/v1/object/public/ipay_uploads/resources/import-users-template.xlsx',
  importUsersBusinessTemplateUrl: 'https://lggeiriskhriqtvjfsqm.supabase.co/storage/v1/object/public/ipay_uploads/resources/import-users-business-template.xlsx'
};
